import { categories } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20overlapping%20soft%20circles%20and%20squares%20in%20warm%20terracotta%20sage%20green%20and%20sand%20tones%2C%20modern%20minimalist%20texture%20background%2C%20artistic%20gradient%20blending%20with%20organic%20shapes%2C%20elegant%20smooth%20surfaces%2C%20contemporary%20art%20gallery%20aesthetic%2C%20subtle%20depth%20and%20atmospheric%20feel%2C%20no%20text%20or%20typography%2C%20warm%20sophisticated%20color%20palette%20with%20cream%20highlights&width=1600&height=900&seq=hero-bg-v2-001&orientation=landscape"
          alt="ACBuySpreadsheet - Order tracking system with structured management for smarter purchasing"
          title="ACBuySpreadsheet - Order Tracking System for Smarter Buys"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight tracking-tight">
            ACBuy <span className="block text-white/90 font-light italic">Spreadsheet</span>
          </h1>
          <p className="mt-4 md:mt-6 text-lg md:text-xl text-white/80 font-light leading-relaxed max-w-lg">
            The ultimate structured order tracking system for smarter purchasing decisions.
          </p>
          <p className="mt-3 text-sm md:text-base text-white/60 max-w-md">
            A data-driven ACBuy spreadsheet system designed to help you track orders, compare costs, and optimize your buying process with full transparency.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-3 mt-8 md:mt-10">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              ACBuy Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white rounded-lg text-sm md:text-base font-medium hover:bg-white/25 transition-colors whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-shopping-cart-line"></i>
            </a>
            <a
              href="#categories"
              className="inline-flex items-center gap-2 px-4 py-3 text-white/70 hover:text-white text-sm font-medium transition-colors whitespace-nowrap"
            >
              Browse Categories
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}